module.exports = __webpack_public_path__ + "img/undraw_wind_turbine_x2k4.3e5d4e66.svg";